import { useBootstrapQuery, useMeQuery } from "../../api/queries";
import { canReview } from "../../advertise/advertiserRules";

export type ReviewerAccess = "loading" | "guest" | "no_role" | "reviewer";

/**
 * Whether to show the review page and links (moderator / admin). Roles come from the account's own
 * `GET /me` (the bootstrap summary may not list them). This only hides UI: the review routes check
 * the role on every request, and a forged role here gets nothing from the server.
 */
export function useReviewerAccess(): { access: ReviewerAccess; roles: string[] } {
  const boot = useBootstrapQuery();
  const signedIn = Boolean(boot.data?.session.userId);
  const me = useMeQuery(signedIn);
  const roles = [...new Set([...(boot.data?.session.roles ?? []), ...(me.data?.roles ?? [])])];
  if (boot.isPending) return { access: "loading", roles };
  if (!signedIn) return { access: "guest", roles };
  if (canReview(roles)) return { access: "reviewer", roles };
  if (me.isPending) return { access: "loading", roles };
  return { access: "no_role", roles };
}
